import { Box, Typography } from '@mui/material'

export default function ValueVariationWrapper({ children, isOutdated, variation }) {
  return (
    <Box sx={{ alignItems: 'center', display: 'flex' }}>
      {children}
      {variation && !isOutdated ? (
        <Typography variant="caption" sx={{ color: '#808080', marginLeft: '6px' }}>
          {variation}
        </Typography>
      ) : undefined}
    </Box>
  )
}
